<template>  
    <div class="loginContainer">  
       <div class="login-field">
         <label><span>Benutzername</span></label>
         <input type="text" name="Nutzername" v-model="userName"/>
       </div>     
       <div class="login-field">
         <label><span>Email-Adresse</span></label>
         <input type="text" name="Email-Adresse" v-model="email"/>
       </div>
       <div class="loginToolsRow">
        <button style="flex-grow: 1" class="MIP_AbstandOben" @click="resetPassword">Passwort zurücksetzen</button>
        <form style="flex-grow: 1" class="MIP_AbstandOben" action="login.html">
          <button style="width: 100%" type="submit" value="Abbrechen">Zurück</button>
        </form>
       </div>
       
    </div>
</template>

<script>
import { ref } from "vue";

import apifetch from "vueforms/src/utils/apifetch";
import windowManager from "vueforms/src/utils/WindowManager";

export default {
  emits: ["done"],
  setup(props, { emit }) {
    const userName = ref(null);
    const email = ref(null);
    
    const resetPassword = async () => {
      if (!userName.value || userName.value == "") {
        windowManager.message("Bitte geben Sie einen Benutzernamen ein.", '<b class="red">Nicht erfolgreich</b>');
        return;
      }
      if (!email.value || email.value == "") {
        windowManager.message("Bitte geben Sie eine Email-Adresse ein.", '<b class="red">Nicht erfolgreich</b>');
        return;
      }
      let result = await apifetch(`useraccount/resetpassword/${userName.value}/${email.value}`,{
        method: "POST",
        headers: {
          "content-type": "application/json"
        }
      }).then(e => e.text());      
      windowManager.message(result, '<b class="red">Erfolgreich</b>');
      emit('done');
    };

    return {
      email,
      userName,
      resetPassword
    }
  }
}
</script>

<style lang="scss">
@import "../assets/variables.scss";

.red {
  color: $PrimaryRed;
}

</style>